//@HACK https://stackoverflow.com/questions/31649362/how-to-make-json-stringify-encode-non-ascii-characters-in-ascii-safe-escaped-for
export const unicodeReplacer = (key: string, value: any) => {
  if (typeof value === 'string') {
    return value.replace(/[\u007F-\uFFFF]/g, ch => '\\u' + ('0000' + ch.charCodeAt(0).toString(16)).slice(-4));
  }

  return value;
};
